/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiToolbarButtonGroupConfig} from "./UiToolbarButtonGroupConfig";
import {UiToolbarButtonConfig} from "./UiToolbarButtonConfig";
import {UiItemViewConfig} from "./UiItemViewConfig";
import {UiDropDownButtonClickInfoConfig} from "./UiDropDownButtonClickInfoConfig";


export interface AbstractUiToolContainerConfig extends UiComponentConfig {
	_type?: string;
	buttonGroups: UiToolbarButtonGroupConfig[];
	backgroundColor?: string
}

export interface AbstractUiToolContainerCommandHandler {
	setButtonVisible(buttonId: string, visible: boolean): void;
	setButtonGroupVisible(groupId: string, visible: boolean): void;
	addButton(groupId: string, button: UiToolbarButtonConfig, neighborButtonId: string, beforeNeighbor: boolean): void;
	removeButton(buttonId: string): void;
	addButtonGroup(group: UiToolbarButtonGroupConfig): void;
	removeButtonGroup(groupId: string): void;
	setDropDownData(buttonId: string, itemView: UiItemViewConfig): void;
	updateButtonGroups(buttonGroups: UiToolbarButtonGroupConfig[]): void;
}

export interface AbstractUiToolContainerEventSource {
	onToolbarButtonClick: TeamAppsEvent<AbstractUiToolContainer_ToolbarButtonClickEvent>;
	onToolbarDropDownItemClick: TeamAppsEvent<AbstractUiToolContainer_ToolbarDropDownItemClickEvent>;
}

export interface AbstractUiToolContainer_ToolbarButtonClickEvent extends UiEvent {
	_type: "AbstractUiToolContainer.toolbarButtonClick";
	redundancyKey?: string;
	groupId: string;
	buttonId: string;
	dropDownClickInfo: UiDropDownButtonClickInfoConfig
}

export interface AbstractUiToolContainer_ToolbarDropDownItemClickEvent extends UiEvent {
	_type: "AbstractUiToolContainer.toolbarDropDownItemClick";
	redundancyKey?: string;
	groupId: string;
	buttonId: string;
	dropDownGroupId: string;
	dropDownItemId: any
}

